import { Tooltip, Button } from 'antd';
import React from 'react'

const TimeSeriesButtons = ({ isButtonClicked, onClick }) => {
    return (
        <>
            <Tooltip placement='left' title="Times series chart">
                <Button
                    icon={ <i className="fa-solid fa-chart-line" /> }
                    onClick={ onClick.tsc }
                    className={ isButtonClicked.tsc ? "active" : "" }
                />
            </Tooltip>
            
            <Tooltip placement='left' title="Times series render">
                <Button
                    icon={ <i className="fa-solid fa-layer-group" /> }
                    onClick={ onClick.tsr }
                    className={ isButtonClicked.tsr ? "active" : "" }
                />
            </Tooltip>

            <Tooltip placement='left' title="Times series animation">
                <Button
                    icon={ <i className="fa-solid fa-play" /> }
                    onClick={ onClick.tsa }
                    className={ isButtonClicked.tsa ? "active" : "" }
                />
            </Tooltip>
        </>
    )
}

export default TimeSeriesButtons;